"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeSelectorDataSelectorId = exports.TIME_SELECTOR_DEFAULT_TEXTS = void 0;
exports.TIME_SELECTOR_DEFAULT_TEXTS = {
    hours: 'Hours:',
    minutes: 'Minutes:',
    seconds: 'Seconds:',
    am: 'AM',
    pm: 'PM',
    errorHoursRequiredText: 'Please select hours',
    errorMinutesRequiredText: 'Please select minutes',
    errorSecondsRequiredText: 'Please select seconds'
};
exports.timeSelectorDataSelectorId = {
    main: 'timeselector'
};
//# sourceMappingURL=constants.js.map